import React, { useState } from 'react'
import { useWalletContext } from './WalletContext'
import Header from './Header/Header'
import DisclaimerDialog from './DisclaimerDialog'
import Footer from './Footer/Footer'
import { XIcon } from '../svgIcons/XIcon'
import { BraavosLogoIcon } from '../svgIcons/braavosLogoIcon'
import PromotionPopupImage from '../images/bgd/promotionPopup.svg'
import Popup from './Popup'
import { StarsIcon } from '../svgIcons/StarsIcon'
import SwapPage from './Swap/SwapPage'
import BgDark from '../images/bgd/bg_dark.png'
import BgMobile from '../images/bgd/bg_mobile_new.png'

export const pageStyle = {
    backgroundImage: `url(${BgDark})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    width: '100%',
    height: '100%',
    minHeight: '100vh',
    zIndex: -1,
    top: 0
}
export const pageStyleMobile = {
    backgroundImage: `url(${BgMobile})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    width: '100%',
    height: '100%',
    minHeight: '100vh',
    zIndex: -1,
    top: 0
}

const Main = () => {
    const [isShowPromotionPopup, setIsShowPromotionPopup] = useState(false)
    const { networkName: network, connect } = useWalletContext()

    // useEffect(() => {
    //     connect(true)
    // }, [])

    const onWalletConnected = async () => {
        // console.log('Wallet connected')
    }
    const onWalletDisconnected = async () => {
        // console.log('Wallet disconnected')
    }

    const disclaimerDialogForMainnet = () => {
        if (network && network.includes('mainnet')) return <DisclaimerDialog />
        return <></>
    }

    function getSelectedTab() {
        // if (searchParams.get('isPools')) return 'pools'
        return 'swap'
    }

    function renderDontHaveWalletPrompt() {
        return (
            <div className='text-[16px] mt-[24px] lg:mt-[50px]'>
                <span>Don't have a</span>
                <span className='font-bold mx-2'>Braavos</span>
                <span>wallet?</span>
                <a
                    className='text-[#538DFF] underline'
                    href='https://braavos.app/download-braavos-wallet/?utm_source=myswapBanner&utm_medium=mySwap&utm_campaign=stake'
                    target='_blank'>
                    Download now!
                </a>
            </div>
        )
    }

    function renderPromotionPopup() {
        if (!isShowPromotionPopup) return null

        return (
            <Popup
                onClose={() => setIsShowPromotionPopup(false)}
                contentClassName={'relative border-none border-[0px] lg:p-[46px] p-[30px] max-w-[306px] lg:max-w-[555px]'}
                background={'linear-gradient(rgba(50, 50, 50, 1), rgba(23, 20, 20, 1))'}
                open={true}>
                <>
                    <div className='flex flex-col'>
                        <div className='flex justify-center lg:justify-start relative'>
                            <BraavosLogoIcon className='h-[30px] w-[123px] lg:h-[40px] lg:w-[160px] mr-[30px]' />
                            <StarsIcon className='lg:relative right-[36px] lg:right-[auto] top-[-25px] absolute' />
                        </div>
                        <div className='flex lg:flex-row flex-col mt-[20px] text-center lg:text-left items-center'>
                            <span className='font-light text-[20px] lg:text-[28px] mt-[10px] font-normal'>
                                <span>{`Open your Braavos wallet and click the`}</span>
                                <span className='mx-2 font-bold'>{'Stake+'}</span>
                                <span className=''>{`button`}</span>
                                <div className='hidden lg:flex'>{renderDontHaveWalletPrompt()}</div>
                            </span>
                            <img className='lg:mt-0 mt-[30px] h-[193px] w-[146px] lg:w-[193px] lg:h-[250px]' src={PromotionPopupImage} />
                        </div>
                        <div className='flex lg:hidden text-center'>{renderDontHaveWalletPrompt()}</div>
                    </div>
                    <XIcon onClick={() => setIsShowPromotionPopup(false)} className='absolute top-[16px] right-[16px] cursor-pointer w-4 h-4' />
                </>
            </Popup>
        )
    }

    return (
        <div className='h-full relative pb-[48px] lg:pb-0'>
            {renderPromotionPopup()}
            <div className='lg:pt-6 max-w-[98%] m-auto'>
                <Header className='' selectedTab={getSelectedTab()} onWalletConnected={onWalletConnected} onWalletDisconnected={onWalletDisconnected} />
            </div>
            <div className={`pb-[65px] container w-full lg:px-0 px-4 py-4 mx-auto max-w-[528px]`}>
                <SwapPage key={network} />
            </div>
            <Footer selectedTab={getSelectedTab()} />
            {disclaimerDialogForMainnet()}
            <div style={pageStyle} className={`hidden lg:flex z-0 absolute h-full w-full bg-[#00176A] pointer-events-none`} />
            <div style={pageStyleMobile} className={`lg:hidden z-0 absolute h-full w-full bg-[#00176A] pointer-events-none`} />
        </div>
    )
}

export default Main
